import { render } from "./InformationList.vue?vue&type=template&id=47420714"
import script from "./InformationList.vue?vue&type=script&lang=js"
export * from "./InformationList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\bp-kmiyajima\\Documents\\Projects\\noritz-portal\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__